import { sliderConstants } from '../constants';
import { sliderService } from '../../services';

export const sliderActions = {
  slidersList,
  addSlider,
  getSlider,
  updateSlider
}

/*
ACTION: Sliders List
*/
function slidersList(addToast, pageID, perPage) {
  return dispatch => {
    dispatch(request());
    return sliderService.slidersList(pageID, perPage)
      .then(
        response => {
          dispatch(success(response.data.body.sliders[0], response.data.body.sliders[0] ? response.data.body.sliders[0].images.length : 0));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: sliderConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: sliderConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: sliderConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Slider
*/
function addSlider(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return sliderService.addSlider(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: sliderConstants.ADD_REQUEST } }
  function success(status) { return { type: sliderConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: sliderConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Slider By ID
*/
function getSlider(addToast, sliderID) {
  return dispatch => {
    dispatch(request());
    return sliderService.getSlider(sliderID)
      .then(
        response => {
          dispatch(success(response.data.body.images.find(item => item.id == sliderID)));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: sliderConstants.GET_REQUEST } }
  function success(item) { return { type: sliderConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: sliderConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Slider
*/
function updateSlider(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return sliderService.updateSlider(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: sliderConstants.UPDATE_REQUEST } }
  function success(status) { return { type: sliderConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: sliderConstants.UPDATE_FAILURE, error } }
}